// NOTE::
// THIS TEXT EDITOR IS CUSTOMIZED WITH THE HELP OF CHATGPT

import {useEditor, EditorContent} from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import TextAlign from '@tiptap/extension-text-align'
import Image from '@tiptap/extension-image'
import Menubar from './Menubar'
import {FileAttachment} from './FileAttachment'
import {ImageWithClass} from './ImageWithClass'
import {useEffect} from 'react'

type Props = {
  content: string
  onContentChange: (content: string) => void
  isFile?: boolean
}

const RichTextEditor = ({content, onContentChange, isFile = true}: Props) => {
  let editor = useEditor({
    extensions: [
      StarterKit,
      Underline,
      TextAlign.configure({
        types: ['heading', 'paragraph'],
      }),
      Image,
      ...(isFile ? [FileAttachment, ImageWithClass] : []),
    ],
    content: content,
    editorProps: {
      attributes: {
        class:
          'form-control form-control-lg form-control custom-input form-textarea h-100 min-h-200px mt-6',
      },
    },
    onUpdate: ({editor}) => {
      // console.log(editor.getHTML());
      onContentChange(editor.getHTML())
    },
  })

  useEffect(() => {
    if (editor && content !== editor.getHTML()) {
      editor.commands.setContent(content)
    }
  }, [content, editor])

  return (
    <div>
      <Menubar editor={editor} isFile={isFile} />
      <EditorContent editor={editor} />
    </div>
  )
}

export default RichTextEditor
